import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "font-weight-bold mb-4" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-header header-elements-inline bg-white d-flex flex-row justify-content-between" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "Übersicht Ihrer Tickets", -1)
const _hoisted_6 = {
  key: 0,
  class: "media-list media-list-linked media-list-bordered"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "mr-3 align-self-center d-flex flex-column align-items-center" }
const _hoisted_9 = { class: "media-body align-self-center d-flex flex-column" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "text-muted" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "ml-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "list-icons" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "list-icons-item"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right15" })
    ])
  ])
], -1)
const _hoisted_13 = {
  key: 1,
  class: "card-body"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "alert alert-info col-12 mb-0" }, "Sie haben noch keine Tickets", -1)
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.headline), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-accent",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.newTicket && _ctx.newTicket(...args)))
        }, "Neue Anfrage")
      ]),
      (_ctx.tickets.length > 0)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tickets, (ticket, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: ""
              }, [
                _createElementVNode("a", {
                  class: "media cursor-pointer align-items-center",
                  onClick: ($event: any) => (_ctx.showDetail(ticket.action, ticket.actionTarget))
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("a", {
                      class: _normalizeClass(["btn bg-transparent rounded-pill border-2 btn-icon", 'text-'+ticket.class])
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(ticket.icon)
                      }, null, 2)
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass('text-'+ticket.class)
                    }, " #" + _toDisplayString(ticket.id), 3)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", null, [
                      _createTextVNode(_toDisplayString(ticket.name) + " ", 1),
                      (ticket.extendName != '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, " - " + _toDisplayString(ticket.extendName), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(ticket.date), 1)
                  ]),
                  _hoisted_12
                ], 8, _hoisted_7)
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
    ])
  ]))
}